// Senior Citizen / PWD discount math (RA 9994 / RA 10754).
//
// Law: on a SC/PWD transaction the VAT is REMOVED from vatable lines first
// (the line becomes VAT-exempt), THEN a statutory % discount is applied to
// the VAT-net amount. This MUST mirror the backend (routes/sales.py) exactly
// so the cash total the cashier sees matches the posted invoice.

const r2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

/**
 * @param {Array<{total:number, vat_class?:string}>} lines  Cart/order lines (gross VAT-inclusive line totals).
 * @param {Object} opts
 * @param {number} opts.vatRate        VAT rate as a percent (e.g. 12).
 * @param {number} opts.scpwdPct       SC/PWD discount as a percent (e.g. 20).
 * @param {boolean} opts.isVatBranch   Whether the branch is VAT-registered.
 * @returns {{gross:number, vatExempt:number, vatAmount:number, discount:number, netDue:number}}
 */
export function computeScpwd(lines, { vatRate = 12, scpwdPct = 20, isVatBranch = true }) {
  const divisor = 1 + Number(vatRate) / 100;
  let gross = 0, vatExempt = 0, vatAmount = 0, discount = 0, netDue = 0;
  for (const l of lines || []) {
    const lineGross = Number(l.total) || 0;
    const vc = l.vat_class || 'vatable';
    const vatable = isVatBranch && vc !== 'vat_exempt' && vc !== 'zero_rated';
    const net = vatable ? r2(lineGross / divisor) : r2(lineGross);
    const removed = r2(lineGross - net);
    const disc = r2((net * Number(scpwdPct)) / 100);
    const due = r2(net - disc);
    gross += lineGross;
    vatExempt += net;
    vatAmount += removed;
    discount += disc;
    netDue += due;
  }
  return {
    gross: r2(gross),
    vatExempt: r2(vatExempt),
    vatAmount: r2(vatAmount),
    discount: r2(discount),
    netDue: r2(netDue),
  };
}
